export default __webpack_public_path__ + "static/media/ni.eb2a7225.svg";